import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SvgIconsService } from '../svg-icons.service';

@Component({
  selector: 'app-svg-icon',
  imports: [],
  templateUrl: './svg-icon.html',
  styleUrl: './svg-icon.scss',
})
export class SvgIconComponent implements OnInit, OnChanges {
  @Input() name!: string;
  svg?: SafeHtml;

  constructor(
    private svgService: SvgIconsService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnChanges() {
    const svgString = this.svgService.getSvg(this.name);
    if (svgString) {
      this.svg = this.sanitizer.bypassSecurityTrustHtml(svgString);
    }
  }

  ngOnInit() {
    const svgString = this.svgService.getSvg(this.name);
    if (svgString) {
      this.svg = this.sanitizer.bypassSecurityTrustHtml(svgString);
    }
  }
}
